import './applicant-program-layout.scss';
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import Back from "../../../../components/UI/Back/Back";
import {useQueryPrograms} from "../../../../api/admin/useQueryPrograms";
import React, {useContext} from "react";
import {PortfolioContext} from "../../../../hooks/Context/PortfolioContext";
import NavigationTabs from "../../../../components/UI/NavigationTabs/NavigationTabs";
import Loading from "../../../../components/UI/Loading/Loading";
import PortfolioStatusButtons from "../../../../components/Payment/SubmitPaymentButton";
import Checkbox from "../../../../components/UI/Checkbox/Checkbox";
import {UserContext} from "../../../../hooks/Context/UserContext";
import NotificationRequired from "../../../../components/UI/Notification/NotificationRequired";

const ApplicantProgramLayout = () => {
  const [user] = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  const {portfolio_id, program_id} = useParams();
  const [portfolio] = useContext(PortfolioContext);

  const {data: currProgram, isLoading} = useQueryPrograms({
    portfolio_id: portfolio_id ? portfolio_id : portfolio.id,
    program_id: program_id,
    userIsSoft: user.isSoft
  });

  if (isLoading) {
    return <Loading loading/>
  }

  return <div className={'applicant-program-layout'}>
    {
      currProgram?.has_quiz
        ? <NotificationRequired>
          Action required: Complete quiz requested for course outcome below.
        </NotificationRequired>
        : null
    }
    <Back
      text={'Back to Recommendations'}
      onClick={() => navigate(`/cpl-applicant/${portfolio_id ? portfolio_id : 'my-programs'}`)}
    />
    <div className={'applicant-program-layout-title'}>
      {currProgram.name}
    </div>
    <div className={'applicant-program-layout-courses'}>
      {currProgram.num_courses_recommended} courses recommended
    </div>

    {
      !portfolio_id
        ? <PortfolioStatusButtons/>
        : null
    }

    <NavigationTabs tabs={[
      {
        name: 'Recommended courses',
        active: !location.pathname.includes('details'),
        onClick: () => navigate(`/cpl-applicant/${portfolio_id ? portfolio_id : 'my-programs'}/${program_id}`)
      },
      {
        name: 'Program details',
        active: location.pathname.includes('details'),
        onClick: () => navigate(`/cpl-applicant/${portfolio_id ? portfolio_id : 'my-programs'}/${program_id}/details`)
      }
    ]}/>

    <Outlet/>
  </div>
}

export default ApplicantProgramLayout;